"use client"

import { useEffect } from "react"
import { captureAnalyticsEvent } from "@/lib/analytics/posthog-client"

export function Page404Tracker() {
  useEffect(() => {
    captureAnalyticsEvent("page_404_hit", {
      missing_path: typeof window !== "undefined" ? window.location.pathname : null,
    })
  }, [])

  return null
}
